module.exports = __webpack_public_path__ + "static/media/snare.d6c14d49.mp3";